









import {Component, Prop, Vue} from 'vue-property-decorator';
import Button from '@/components/input-controls/Button.vue';

/**
 * variation of Button for primary action
 */
@Component({
	components: {
		Button,
	},
})
export default class ButtonPrimary extends Vue {
	@Prop({default: false})
	inverted!: boolean;

	get color() {
		return this.inverted ? 'white' : 'action-primary';
	}

	get textColor() {
		return this.inverted ? 'action-primary' : 'white';
	}
}
